module.exports = __webpack_public_path__ + "static/media/youtube.0bf78019.webp";